import { Typography } from 'antd';
import React from 'react';
import FormEditBoUser from '../components/FormEditBoUser';

const EditBoUser: React.FC = () => (
  <div>
    <Typography.Title level={3} style={{ fontWeight: 'bold' }}>Edit admin user</Typography.Title>
    <FormEditBoUser />
  </div>
);

export default EditBoUser;
